import React, { useState } from 'react';

import CityLinkServices from 'services/CityLink';
import useToggleDrawer from 'hooks/useToggleDrawer';
import PageTitle from 'components/Typography/PageTitle';
import MainDrawer from 'components/drawer/MainDrawer';

import { useContext } from 'react';
import { SidebarContext } from 'context/SidebarContext';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound'; // Import NotFound component
import { FiRefreshCcw } from 'react-icons/fi';
import DeleteModal from 'components/modal/DeleteModal';
import useAsync from 'hooks/useAsync';
import CityLinkTable from 'components/cityLink/cityLinkTable';

import { FiPlus } from 'react-icons/fi';import {
    Card,
    CardBody,
    Input,
    Table,
    TableCell,
    TableContainer,
    TableHeader,
    Button,
} from '@windmill/react-ui';
import sidebar from 'routes/sidebar';
import ExportDataXlsx from 'components/common/ExportDataXlsx';

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const CityLink = () => {
    const adminInfo = localStorage.getItem('adminInfo')
        ? JSON.parse(localStorage.getItem('adminInfo'))
        : null;
    const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
    const [searchText, setSearchText] = useState('');
    const { data, loading, error } = useAsync(() => CityLinkServices.getAllCityLink());
    const [status] = useState('');
    const isDataArray = Array.isArray(data?.data); // Check if data is an array
    const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

    const isAdmin = adminInfo?.id === 1;

    const hideView = isAdmin
        ? true
        : adminInfo?.permission?.some(
                (perm) => perm.id_tab === 'city link' && perm.view === 1
          );

    const hideDelete = isAdmin
        ? true
        : adminInfo?.permission?.some(
                (perm) => perm.id_tab === 'city link' && perm.delete === 1
          );

    const hideEdit = isAdmin
        ? true
        : adminInfo?.permission?.some(
                (perm) => perm.id_tab === 'City link' && perm.edit === 1
          );

    const hideAdd = isAdmin
        ? true
        : adminInfo?.permission?.some(
                (perm) => perm.id_tab === 'city link' && perm.add === 1
          );

    const hideExport = isAdmin
        ? true
        : adminInfo?.permission?.some(
                (perm) => perm.id_tab === 'city link' && perm.export === 1
          );

    const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
        useToggleDrawer();

    // Contains the column headers and table data in the required format for CSV

    const csvData = [
        ['Country', 'State', 'CityLink'],
        ...safeData.map(({ country_name, state_name, name }) => [
            country_name,
            state_name,
            name,
        ]),
    ];

    const filteredData = safeData.filter(
        (item) =>
            (item.name !== null &&
                item.name.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.state_name !== null &&
                item.state_name.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.country_name !== null &&
                item.country_name.toLowerCase().includes(searchText.toLowerCase()))
    );

    const handleRefresh = () => {
        setIsUpdate(true);
    };
    return (
        <>
            {hideView && (
                <>
                    <DeleteModal id={serviceId} title={title} />

                    <style>{style}</style>
                    <PageTitle sidebar={sidebar().sidebar} />

                    <MainDrawer>
                        
                    </MainDrawer>

                    <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
                        <CardBody>
                            <form className="flex gap-6 items-center">
                                <div className="flex-1">
                                    <Input
                                        className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                                        type="search"
                                        name="search"
                                        autoComplete="off"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder="Quick Search"
                                    />
                                </div>


                                {hideExport && (
                                    <div className="items-center">
                                        <ExportDataXlsx
                                            title="CityLink"
                                            exportDataXlsx={csvData}
                                            fileNames="CityLink List"
                                        />
                                    </div>
                                )}

                                <FiRefreshCcw
                                    onClick={() => {
                                        handleRefresh();
                                    }}
                                    cursor="pointer"
                                />
                            </form>
                        </CardBody>
                    </Card>

                    <div className="data-table-container">
                        <DataWrapper loading={loading} error={error} status={status}>
                            {filteredData.length > 0 ? (
                                <TableContainer
                                    className="mb-8"
                                    style={{
                                        maxHeight: '65vh',
                                        overflowY: 'scroll',
                                        scrollbarWidth: 'thin',
                                    }}
                                >
                                    <Table>
                                        <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                                            <tr>
                                                <TableCell className="text-center">Sl.No.</TableCell>
                                                <TableCell className="text-center">City</TableCell>
                                              
                                                <TableCell className="text-center">Actions</TableCell>
                                            </tr>
                                        </TableHeader>

                                        <CityLinkTable
                                            id={data.id_CityLink}
                                            title={data.name}
                                            CityLinkdata={filteredData}
                                            isSubmitting={isSubmitting}
                                            handleUpdate={handleUpdate}
                                            handleModalOpen={handleModalOpen}
                                            hideDelete={hideDelete}
                                            hideEdit={hideEdit}
                                        />
                                    </Table>
                                </TableContainer>
                            ) : (
                                // Show NotFound if there is no data
                                <NotFound title="There are no CityLink." />
                            )}
                        </DataWrapper>
                    </div>
                </>
            )}
        </>
    );
};

export default CityLink;
